// export const MY_POST_URl_WITHOUTFORWARD: string = 'posts/mine';
// export const MY_POST_URl: string = '/' + MY_POST_URl_WITHOUTFORWARD;

export const BRAND_NAME: string = 'Circle Post';

export const ROUTE_MY_POSTS: string = '/posts/mine';
export const ROUTE_WORLD_FEED: string = '/feed/world';
export const ROUTE_INNER_CIRCLE_FEED: string = '/feed/inner-circle';
export const ROUTE_CONNECTIONS_FEED: string = '/feed/connections';
export const ROUTE_NEWS_FEED: string = '/feed/news';

// export const SIGN_IN_PAGE_URl_NEW: string = 'new-auth/all';
// export const SIGN_IN_PAGE_URl_WITHFORWARD: string = '/' + SIGN_IN_PAGE_URl_NEW;
export const FAQ_WEB_URL: string = 'https://prjmay2026.web.app/faq';

export const NEW_SIGN_IN_PAGE_URL: string = '/new-auth/all' ;

export const WORD_WORLD = 'WORLD';
export const WORD_WORLD_Camel = 'World';
export const WORD_WORLD_PUBLIC = 'World (public)';
//
export const WORD_INNER_CIRCLE = 'INNER_CIRCLE';
export const WORD_INNER_CIRCLE_Camel = 'Inner Circle';
//
export const WORD_CONNECTION_ONLY = 'CONNECTION_ONLY';
export const WORD_CONNECTIONS_Camel = 'Connections';

export const WORD_PRIVATE_Camel = 'Private';
export const WORD_NO_ONE_PRIVATE = 'No one (private)';

export const MAX_TAGS_ALLOWED = 5;
export const TAG_PATTERN = /^[A-Za-z][A-Za-z0-9]*(?:-[A-Za-z0-9]+)*$/;

export type FeedTab =
  | typeof WORD_INNER_CIRCLE
  | typeof WORD_CONNECTION_ONLY
  | typeof WORD_WORLD;

export const STATUS_PENDING = 'PENDING';
export const STATUS_ACCEPTED = 'ACCEPTED';
export const STATUS_DENIED = 'DENIED';
export const STATUS_CANCELLED = 'CANCELLED';
export const STATUS_BLOCKED = 'BLOCKED';
export const STATUS_DISCONNECTED = 'DISCONNECTED';

export const ROUTE_REQUESTS_INBOX = '/requests/inbox';
export const ROUTE_REQUESTS_SENT = '/requests/sent';
export const ROUTE_REQUESTS_SEND = '/requests/send';
export const ROUTE_REQUESTS_DETAIL = '/requests/detail';

export const ROUTE_PEOPLE_INNER_CIRCLE = '/circle/members';
export const ROUTE_PEOPLE_CONNECTION_ONLY = '/circle/connections';

export const ROUTE_NOTIFICATIONS = '/notifications';
